import { useQuery } from "@tanstack/react-query";
import apiClient from "@/src/services/api/axios";
import { BLOCKS_ENDPOINTS } from "@/src/services/blocks/config";

export type BlocksLanguage = {
  itemId: string;
  languageName: string;
  languageCode: string;
};

/**
 * The project's configured languages, for the settings switcher.
 *
 * v4: `GET /localization/v4/Language/Gets` (was `/uilm/v1/Language/Gets`, now a
 * 404). Verified live 2026-07-30 with no session and no `ProjectKey` param — the
 * `x-blocks-key` header scopes it — returning en-US (default), de-DE and bn-BD
 * with exactly the `{itemId, languageName, languageCode}` fields below, plus an
 * `isDefault` flag this type does not model.
 */
export const useGetLanguages = () => {
  return useQuery({
    queryKey: ["languages"],
    queryFn: async () => {
      const res = await apiClient.get(BLOCKS_ENDPOINTS.languages);
      return res.data as BlocksLanguage[];
    },
  });
};
